class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
// Recommended product
class RecomProduct extends HTMLElement {
  constructor() {
    super();
    this.connectedCallback();
    this.swiper = new Swiper(this.querySelector('.swiper.recommendedProductSwiper.mySwiper'), {  
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 10,
      pagination: {
       el: ".recommendedProductSwiper-swiper-pagination",
       clickable: true,
      },
      breakpoints: {
       0: {
         slidesPerView: 2,
         spaceBetween: 10,
       },
       768: {
         slidesPerView: 3,
         spaceBetween: 10,
       },
       1024: {
         slidesPerView: 3,
         spaceBetween: 10,
       },
      } 
    })  
  }
    async connectedCallback() {
    var recommendProducts= [];
    const productId = this.getAttribute('data-product-id');
    const res = await fetch(`/recommendations/products.json?product_id=${productId}&limit=9`);
    const data = await res.json();
      // console.log(data, 'res res');
      var recommendProducts = data.products.map(product => {
        var dollarsPrice = product.price / 100;  
        let prodImg;
        if (product.featured_image !== null) {
          prodImg = product.featured_image.replace(/(\.[^.]*)$/, "_180x$1");
        } else {
          prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
        }
        return {
          title: product.title,
          url: product.url,
          price: dollarsPrice,
          image: prodImg
        };
      });
      let html = '';
      recommendProducts.forEach(product=>{
        html += `
        <div class="swiper-slide">
          <a href="${product.url}">
            <div class="recomendedProductBlock">
              <div class="recomendedProductImage">
                <img src="${product.image}" alt="${product.title}">
              </div>
              <div class="recomendedProductsContent">
                <h3>${product.title}</h3>
                <div class="priceTag">
                 ADD $${product.price}
                </div>
              </div>
            </div>
          </a>
        </div>
        `
      })      
      this.querySelector('.swiper-wrapper').innerHTML = html
      // console.log(recommendProducts , '1212');
    
  }
}
customElements.define('recomended-porduct-drawer', RecomProduct);
